import { render, staticRenderFns } from "./ProfileCatalogGroup.vue?vue&type=template&id=39e5858c&"
import script from "./ProfileCatalogGroup.vue?vue&type=script&lang=js&"
export * from "./ProfileCatalogGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports